import type { VerticalPageJobType } from 'modules/job-types/types';

type JobTypeDisplayOptions = { shouldUseSEOName: boolean };
export const getJobTypeDisplayName = (
  jobType: VerticalPageJobType,
  { shouldUseSEOName }: JobTypeDisplayOptions = { shouldUseSEOName: false }
) =>
  shouldUseSEOName && jobType.translations.seoName
    ? jobType.translations.seoName
    : jobType.translations.requestType;

export const JOB_TYPE_ID_DEFAULT = 'unknown-jobTypeId';
